import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./QuickView.scss";
import CancelIcon from "@mui/icons-material/Cancel";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useAuth } from "../context/AuthContext";
import {
  buildMediaUrl,
  fetchTitleDetails,
  getDirectPlayPath,
  getTitlePath,
} from "../services/streamApi";

function QuickView({ movie, popup, popupStatut }) {
  const { user } = useAuth();
  const [details, setDetails] = useState(null);

  useEffect(() => {
    let active = true;

    async function loadDetails() {
      if (!popupStatut || !movie?.id) {
        setDetails(null);
        return;
      }

      try {
        const payload = await fetchTitleDetails(movie.id, user?.userId);
        if (!active) return;
        setDetails(payload);
      } catch (error) {
        console.error("Erreur details titre:", error);
        if (active) setDetails(null);
      }
    }

    loadDetails();
    return () => {
      active = false;
    };
  }, [movie?.id, popupStatut, user?.userId]);

  const titleData = details?.title || movie;
  const seasonsCount = details?.seasons?.length || 0;
  const episodesCount = details?.seasons?.reduce((total, season) => total + season.episodes.length, 0) || 0;
  const isSerialized = titleData?.type === "serie" || titleData?.type === "documentaire";

  return (
    <div className={`quickView ${popupStatut ? "open" : ""}`} onClick={popup}>
      <div className="quickView__dialog" onClick={(event) => event.stopPropagation()}>
        <button className="quickView__close" onClick={popup}>
          <CancelIcon />
        </button>

        <div
          className="quickView__hero"
          style={{
            "--quick-bg": `url("${buildMediaUrl(titleData?.backdropPath || titleData?.posterPath)}")`,
          }}
        >
          <div className="quickView__content">
            <p className="quickView__eyebrow">Selection Premium</p>
            <h3 className="quickView__title">{titleData?.title}</h3>
            <p className="quickView__description">{titleData?.description || "Plus d'infos sur ce titre."}</p>

            <div className="quickView__actions">
              <Link to={getDirectPlayPath(titleData)} className="quickView__button quickView__button--play" onClick={popup}>
                <PlayArrowIcon /> Lecture
              </Link>
              <Link to={getTitlePath(titleData?.id)} className="quickView__button" onClick={popup}>
                <InfoOutlinedIcon /> Fiche complete
              </Link>
            </div>
          </div>
        </div>

        <div className="quickView__details">
          <div className="quickView__facts">
            <span>{titleData?.year || "Catalogue"}</span>
            {titleData?.durationLabel ? <span>{titleData.durationLabel}</span> : null}
            {titleData?.categoryLabel ? <span>{titleData.categoryLabel}</span> : null}
            {titleData?.maturity ? <span>{titleData.maturity}</span> : null}
          </div>

          <div className="quickView__stats">
            <div>
              <strong>{titleData?.views || 0}</strong>
              <span>lectures</span>
            </div>
            <div>
              <strong>{titleData?.likes || 0}</strong>
              <span>likes</span>
            </div>
            {isSerialized ? (
              <>
                <div>
                  <strong>{seasonsCount}</strong>
                  <span>saisons</span>
                </div>
                <div>
                  <strong>{episodesCount}</strong>
                  <span>episodes</span>
                </div>
              </>
            ) : (
              <>
                <div>
                  <strong>{titleData?.matchScore || 0}%</strong>
                  <span>match</span>
                </div>
                <div>
                  <strong>{titleData?.type === "documentaire" ? "Doc" : "Film"}</strong>
                  <span>format</span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuickView;
